'use strict';

// Vue
import Vue from 'vue';
import router from 'router';

// API
import { requestQuestions, requestStartingQuestion, requestAppointmentStartingQuestion, requestSingleQuestion, requestPreviousQuestion, requestNextQuestion } from 'api/questions';

// State
const state = {};

// Getters
const getters = {
  questions: state => state.questions || [],
  startingQuestion: state => state.startingQuestion || {},
  appointmentStartingQuestion: state => state.appointmentStartingQuestion || {},
  singleQuestion: state => state.singleQuestion || {},
  prevQuestion: state => state.prevQuestion || {},
  nextQuestion: state => state.nextQuestion || {},
  f2fSelected: state => state.f2fSelected || null,
  loadingSingleQuestion: state => state.loadingSingleQuestion || null,
};

// Mutations
const mutations = {
  SET_QUESTIONS(state, payload) {
    Vue.set(state, 'questions', payload);
  },

  SET_STARTING_QUESTION(state, payload) {
    Vue.set(state, 'startingQuestion', payload);
  },

  SET_APPOINTMENT_STARTING_QUESTION(state, payload) {
    Vue.set(state, 'appointmentStartingQuestion', payload);
  },

  SET_SINGLE_QUESTION(state, payload) {
    Vue.set(state, 'singleQuestion', payload);
  },

  SET_PREVIOUS_QUESTION(state, payload) {
    Vue.set(state, 'prevQuestion', payload);
  },

  SET_NEXT_QUESTION(state, payload) {
    Vue.set(state, 'nextQuestion', payload);
  },

  SET_F2F_SELECTION(state, payload) {
    Vue.set(state, 'f2fSelected', payload);
  },

  SET_LOADING_SINGLE_QUESTION(state, payload) {
    Vue.set(state, 'loadingSingleQuestion', payload);
  },
};

// Actions
const actions = {
  // Questions
  requestQuestions({ dispatch }) {
    return new Promise((resolve, reject) => {
      requestQuestions()
        .then(response => {
          dispatch('setQuestions', response.data.results || {});
          resolve(response);
        })
        .catch(error => {
          console.error(error);
          router.push({
            name: 'support',
          });
          reject(error);
        });
    });
  },

  // Staring Question
  requestStartingQuestion({ dispatch }) {
    return new Promise((resolve, reject) => {
      requestStartingQuestion()
        .then(response => {
          dispatch('setStartingQuestion', response.data || {});
          resolve(response);
        })
        .catch(error => {
          router.push({
            name: 'support',
          });
          console.error(error);
          reject(error);
        });
    });
  },

  requestAppointmentStartingQuestion({ dispatch, commit }) {
    commit('auth/SET_HEADERS', 'default', { root: true });

    return new Promise((resolve, reject) => {
      requestAppointmentStartingQuestion()
        .then(response => {
          dispatch('setAppointmentStartingQuestion', response.data || {});
          resolve(response);
        })
        .catch(error => {
          router.push({
            name: 'home',
          });
          console.error(error);
          reject(error);
        });
    });
  },

  // Single Question
  requestSingleQuestion({ dispatch, commit }, id) {
    commit('auth/SET_HEADERS', 'answer', { root: true });
    commit('SET_LOADING_SINGLE_QUESTION', true);

    return new Promise((resolve, reject) => {
      requestSingleQuestion(id)
        .then(response => {
          dispatch('setSingleQuestion', response.data.results || {});
          commit('SET_LOADING_SINGLE_QUESTION', false);
          resolve(response);
        })
        .catch(error => {
          commit('SET_LOADING_SINGLE_QUESTION', false);
          router.push({
            name: 'home',
          });
          // location.reload();
          console.error(error);
          reject(error);
        });
    });
  },

  requestPreviousQuestion({ dispatch, commit }, id) {
    commit('auth/SET_HEADERS', 'answer', { root: true });
    commit('SET_PREVIOUS_QUESTION', true);

    return new Promise((resolve, reject) => {
      requestPreviousQuestion(id)
        .then(response => {
          dispatch('setPreviousQuestion', response.data.results || {});
          commit('SET_PREVIOUS_QUESTION', false);
          resolve(response);
        })
        .catch(error => {
          commit('SET_PREVIOUS_QUESTION', false);
          router.push({
            name: 'home',
          });
          // location.reload();
          console.error(error);
          reject(error);
        });
    });
  },

  requestNextQuestion({ dispatch, commit }, id) {
    // commit(`auth/SET_HEADERS`, `answer`, { root: true });
    commit('SET_NEXT_QUESTION', true);

    return new Promise((resolve, reject) => {
      requestNextQuestion(id)
        .then(response => {
          dispatch('setNextQuestion', response.data.results || {});
          commit('SET_NEXT_QUESTION', false);
          resolve(response);
        })
        .catch(error => {
          commit('SET_NEXT_QUESTION', false);
          router.push({
            name: 'home',
          });
          // location.reload();
          console.error(error);
          reject(error);
        });
    });
  },

  setPreviousQuestion({ commit }, payload) {
    commit('SET_PREVIOUS_QUESTION', payload);
  },

  setNextQuestion({ commit }, payload) {
    commit('SET_NEXT_QUESTION', payload);
  },

  setQuestions({ commit }, payload) {
    commit('SET_QUESTIONS', payload);
  },

  setStartingQuestion({ commit }, payload) {
    commit('SET_STARTING_QUESTION', payload);
  },

  setAppointmentStartingQuestion({ commit }, payload) {
    commit('SET_APPOINTMENT_STARTING_QUESTION', payload);
  },

  setSingleQuestion({ commit }, payload) {
    commit('SET_SINGLE_QUESTION', payload);
  },

  selectFace2Face({ commit }, payload) {
    localStorage.setItem('f2fselected', payload);
    commit('SET_F2F_SELECTION', payload);
  },
};

// Export
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./client/store/questions.js